import { Typography } from 'antd';

const { Title, Text } = Typography;

/**
 * Reusable Form Header Component
 */
export const FormHeader = ({
    mainTitle = '〘 Prakruti Ayurvedic Health Center & Hospital 〙',
    subtitle = 'A Project By Prakruti Ayurvedic Health Resort, Satara',
    formTitle = 'Discharge Summary'
}) => {
    return (
        <div style={{
            textAlign: 'center',
            marginBottom: '32px',
            paddingBottom: '24px',
            borderBottom: '2px solid #f0f0f0'
        }}>
            <Title level={2} style={{ margin: 0, color: '#262626', fontWeight: '600' }}>
                {mainTitle}
            </Title>
            <Text style={{ fontSize: '14px', color: '#8c8c8c', display: 'block', marginTop: '8px' }}>
                {subtitle}
            </Text>
            <div style={{ marginTop: '16px' }}>
                <Title level={4} style={{ margin: 0, color: '#262626' }}>
                    {formTitle}
                </Title>
            </div>
        </div>
    );
};
